import { useState, useCallback } from 'react'
import { getBodyForSavingNotes, saveNotes } from 'src/consumer/services/featureServices'

export const useNotesManagement = () => {
  const [lastSavedNotesEntry, setLastSavedNotesEntry] = useState('')
  const [notesEntry, setNotesEntry] = useState('')
  const [notesEntrySubmitLoading, setNotesEntrySubmitLoading] = useState(false)
  const [notesSavingError, setNotesSavingError] = useState(false)

  const handleSubmitNotes = useCallback(async (bookedEventFinalData, userRole) => {
    if (notesEntry === lastSavedNotesEntry) {
      // No changes to submit
      return
    }

    setNotesEntrySubmitLoading(true)
    setNotesSavingError(false)
    
    const body = getBodyForSavingNotes(bookedEventFinalData?.id, notesEntry)
    let response
    
    if (userRole === 'mentor') {
      response = await saveNotes('mentor', body)
    } else if (userRole === 'panelist') {
      response = await saveNotes('panelist', body)
    } else {
      response = await saveNotes('user', body)
    }
    
    setNotesEntrySubmitLoading(false)
    
    if (response?.status === 200) {
      setLastSavedNotesEntry(body?.content)
    } else {
      setNotesSavingError(true)
    }
  }, [notesEntry, lastSavedNotesEntry])

  return {
    lastSavedNotesEntry,
    setLastSavedNotesEntry,
    notesEntry,
    setNotesEntry,
    notesEntrySubmitLoading,
    setNotesEntrySubmitLoading,
    notesSavingError,
    setNotesSavingError,
    handleSubmitNotes,
  }
}